import Swiper from 'swiper/bundle';

const init = () => {
  const element = document.querySelector('#case-slider');

  if (!element) return;


  const swiper = new Swiper(element, {
    loop: false,
    init: false,
    keyboard: true,
    mousewheel: {
      thresholdDelta: 70,
      forceToAxis: true
    },

    navigation: {
      prevEl: '.case__swiperPrevButton',
      nextEl: '.case__swiperNextButton',
    },

    pagination: {
      clickable: true,
      el: '.case__swiperPagination',
    },

    breakpoints: {
      960: {
        spaceBetween: 20
      },
    }

  });

  swiper.init();
};

export default init;